import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import useEndpoint from '../../Hooks/UseEndpoint';
import PurchaseType from '../Purchase/PurchaseType';
import { formatPrice } from '@frontend-components/utils/formatPrice';
const PriceTag = ({ productType, purchaseType, document = null }) => {
    const [prices, setPrices] = useState();
    const isUpgrade = document && document.purchasedAsType && document.purchasedAsType !== PurchaseType.ADVICE;
    const calculatePrice = () => {
        // If upgrading a product, withdraw the amount already payed from the price.
        if (isUpgrade) {
            return prices[purchaseType] - prices[document.purchasedAsType] > 0
                ? prices[purchaseType] - prices[document.purchasedAsType]
                : 0;
        }
        return prices[purchaseType];
    };
    /**
     * On init, fetch prices.
     */
    useEndpoint(`/api/payment/price/product/${productType}`, (fetchedPrices) => {
        setPrices(fetchedPrices);
    }, `prices_${productType}`);
    if (!prices) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'flex flex-row justify-end w-full pr-5' }, { children: [!isUpgrade && prices.default[purchaseType] > prices[purchaseType] && (_jsx("span", Object.assign({ className: 'line-through text-gray-69 xs:text-lg text-xl' }, { children: formatPrice(prices.default[purchaseType]) }))), _jsx("span", Object.assign({ className: 'font-medium ml-3 text-black xs:text-lg text-xl' }, { children: formatPrice(calculatePrice()) }))] })));
};
PriceTag.propTypes = {
    purchaseType: PropTypes.string.isRequired,
    productType: PropTypes.string.isRequired,
    document: PropTypes.shape({
        purchasedAsType: PropTypes.string,
        isPurchased: PropTypes.bool
    })
};
export default PriceTag;
